import headshot from './myHeadshot copy.jpeg';

function Founder() {
    return (
        <>
            <div className="founder">
                <img src={headshot} alt="Founder headshot" className="headshot" />

            </div>

                  <div class="row">


            <div className="column">
                {/* <p className="founderParagraph">  */}

                <p>My name is Tamera Middlebrooks and I'm the founder of purepostage! I got involved in environmental justice work at the age of 18, when the youth activist non-profit I'd co-founded worked on a water testing project in response to lead contaminated water in surrounding neigborhoods of DPS schools. Since then, I've continued to participate in EJ advocacy here in Detroit, as well as continuing to educate myself (and others) as much as possible on the realities of climate change and human behaviors that contribute to it.
                    {/* <br></br>
                    <br></br> */}
                    </p>
                    </div>

                <div className="column">

                    <p>A few years ago, as I became more passionate about taking direct action through ethical fashion, I had the idea for a sustainable shipping platform that could reduce environmental harm. 
                                       <br></br>

                    Thanks to the MSU Apple Developer Academy, I now have the tools and roadmap to make that vision real. What started as a passion for sustainability in fashion became a commitment to rethinking how small brands ship: with care, transparency, and direct impact.
                </p>
            </div>
            </div>
        </>
    )
}

export default Founder;
